"use client";

import React from "react";
import type { IconProps } from "@/components/icons/icons-utils/icon-props";
import { useIconLayout } from "@/components/icons/icons-utils/use-icon-layout";

// MARK: SortOtherAsc
/**
 * SortOtherAsc icon — add SVG markup inside the root `<svg>`.
 *
 * **Reuse scope:** Project-wide — `@/components/icons` registry.
 */
export const SortOtherAsc: React.FC<IconProps> = (props) => {
    const { resolved_width, resolved_height, effective_stroke_width, className, svg_style, rest } = useIconLayout(props);

    return (
        <svg
            viewBox="0 0 24 24"
            width={resolved_width}
            height={resolved_height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={svg_style}
            strokeWidth={effective_stroke_width}
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            {...rest}
        >
            <path d="M14 14L2 14"></path>
            <path d="M10 10H2"></path>
            <path d="M6 6H2"></path>
            <path d="M18 18H2"></path>
            <path d="M19 14V4"></path>
            <path d="M19 4L22 7"></path>
            <path d="M19 4L16 7"></path>
        </svg>
    );
};

SortOtherAsc.displayName = "SortOtherAsc";
